module.exports = __webpack_public_path__ + "img/coin.855e76af.png";